import React from "react";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getFee = async (queryParams:any) => {
    try {
  return await get<ApiResponse<[]>>(`/fee?${queryParams}`).then((res)=> {
    if(res?.success) {
            return res
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
